// @flow

// This file should be deprecated into seperate selectors.
// This module is seperate because of circular dependencies.

import getComponentSettings from '../../componentSettings/selectors';
import getContactSettings from '../../contactSettings/selectors';
import getFooterSettings from '../../footerSettings/selectors';
import { getMenus } from '../../menus/selectors';
import getOpeningHours from '../../openinghours/selectors';
import getSocialSettings from '../../socialSettings/selectors';
import getSiteSettings from '../../siteSettings/selectors';
import getWpSettings from '../../wpSettings/selectors';

import type {
  WpSettings,
  SiteSettings,
  FooterSettings,
  ComponentSettings,
} from '../../../types';
import type { ContactSettings } from '../../contactSettings/types';
import type { SocialSettings } from '../../socialSettings/types';
import type { Menus } from '../../menus/types';

export type Settings = {
  wpSettings: WpSettings,
  siteSettings: SiteSettings,
  contactSettings: ContactSettings,
  socialSettings: SocialSettings,
  footerSettings: FooterSettings,
  componentSettings: ComponentSettings,
  menus: Menus,
};

export default (state: any): Settings => ({
  componentSettings: getComponentSettings(state),
  contactSettings: getContactSettings(state),
  footerSettings: getFooterSettings(state),
  menus: getMenus(state),
  openingHours: getOpeningHours(state),
  socialSettings: getSocialSettings(state),
  siteSettings: getSiteSettings(state),
  wpSettings: getWpSettings(state),
});
